<!--
Author: zhangkun
Date: 2024-07-01
Desc: 跨系统转托管
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/quickTrade' }">快速交易</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/quickTrade', query: { tab: '5' } }">
                    跨系统转托管
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-trusteeship-fund bizcomp ' + className">
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="转托管基金名称：" class="form-text">
                    <div v-cloak class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item label="银行账号：" prop="transactionaccountid" class="payway-list">
                    <el-radio-group
                        v-model="fundInfo.transactionaccountid"
                        class="bank-radio"
                        vertical
                    >
                        <el-radio
                            v-for="(bank, index) in fund.fundArr"
                            :key="index"
                            :label="bank.transactionaccountid + bank.index"
                            border
                        >
                            <div class="bank-img-sel">
                                <img
                                    :src="
                                        $util.getImg(
                                            bank.paycenterid !== $util.getConfig().const.ZX_CENTER
                                                ? bank.bankcode
                                                : 'hf'
                                        )
                                    "
                                    alt=""
                                />
                                <div class="k-text-flow">
                                    <span
                                        v-cloak
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{
                                            $cache.getDict("110079", bank.paycenterid) +
                                            "-" +
                                            $cache.getDict("110080", bank.bankcode)
                                        }}
                                        （{{ bank.depositcard.substr(-7, 7) }}）
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{ $util.fmtNum(bank.transferusevol) }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="fund.sharetype"
                    label="收费方式："
                    prop="sharetype"
                    class="form-text"
                >
                    <div class="text-con">
                        {{ fund.sharetype == "0" ? "前收费" : "后收费" }}
                    </div>
                </el-form-item>
                <el-form-item label="托管场所：" class="form-text">
                    <div class="text-con">{{ distributorName }}</div>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div v-cloak class="text-con">
                        {{ $util.fmtNum(bankInfo.transferusevol) }}
                        <span class="freeze">份</span>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.targetdistributorcode != '101' &&
                        fundInfo.targetdistributorcode != '102'
                    "
                    label="托管网点："
                    prop="targetbranchcode"
                >
                    <el-input
                        v-model.trim="fundInfo.targetbranchcode"
                        class="prefix"
                        placeholder="请输入托管网点"
                        :maxlength="20"
                    />
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.targetdistributorcode == '101' ||
                        fundInfo.targetdistributorcode == '102'
                    "
                    label="席位号："
                    prop="targetbranchcode"
                >
                    <el-input
                        v-model.trim="fundInfo.targetbranchcode"
                        class="prefix"
                        placeholder="请输入席位号"
                        :maxlength="20"
                    />
                    <el-tooltip placement="top">
                        <div slot="content">
                            席位号是您证券交易账户所归属的券商营业部在证券交易所开立的席位号码。
                            <br />
                            为了本交易能准确无误执行，建议您与证券交易账户对应的券商营业网点联系并确认。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.targetdistributorcode != '101' &&
                        fundInfo.targetdistributorcode != '102'
                    "
                    label="托管交易账号："
                    prop="targettransactionaccountid"
                >
                    <el-input
                        v-model.trim="fundInfo.targettransactionaccountid"
                        class="prefix"
                        placeholder="请输入托管交易账号"
                        :maxlength="20"
                    />
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.targetdistributorcode == '101' ||
                        fundInfo.targetdistributorcode == '102'
                    "
                    label="股东账号："
                    prop="targettransactionaccountid"
                >
                    <el-input
                        v-model.trim="fundInfo.targettransactionaccountid"
                        class="prefix"
                        placeholder="请输入股东账号"
                        :maxlength="20"
                    />
                </el-form-item>
                <el-form-item
                    label="转出份额："
                    prop="amount"
                    :class="{ 'form-text': !isPwdCheck }"
                >
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                        v-on:input="handleInput"
                    />
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <span
                        class="redemp-btn"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="font-size: 14px; display: flex; align-items: flex-start"
                    >
                        <div style="display: flex; align-items: center">
                            <input v-model="checkbox" type="checkbox" />
                            <span class="check-text">我已阅读并同意:</span>
                        </div>
                        <ul>
                            <li v-for="(item, index) in readFileInfoList" :key="index">
                                <a
                                    class="cursor-pointer"
                                    target="_blank"
                                    v-on:click="getClick(index)"
                                >
                                    《{{ item.filename }}》
                                </a>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%; margin-left: 70px">
                        <el-button class="medium back" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="checkBuy == false"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                            <span id="time"></span>
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="$router.push({ name: 'traderecord' })"
                v-on:return-login="$router.push({ name: 'home' })"
            />
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="finishReading"
            ></pdf-popup>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import commonApi from "@/api/common";

export default {
    name: "TrusteeshipFund",
    components: {
        PdfPopup,
        result
    },
    mixins: [mixin],
    data() {
        return {
            fundInfo: {
                availablevol: "",
                amount: "",
                transactionaccountid: "",
                targetbranchcode: "",
                targettransactionaccountid: "",
                targetdistributorcode: "",
                pwd: ""
                // protocol: ""
            },
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            checkBuy: true,
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            interval: "",
            isPwdCheck: false,
            isAmountAll: false,
            pla: "",
            fund: {}, // 基金信息获取
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的转托管申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            query: null,
            rules: {
                targetbranchcode: [{ validator: this.validateTargetbranchcode, trigger: "blur" }],
                targettransactionaccountid: [
                    { validator: this.validateTargettransactionaccountid, trigger: "blur" }
                ],
                amount: [{ validator: this.amountLimit, trigger: "blur" }],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            limit: { min: "0", max: "0", text: "转托管份额范围为：" },
            ZX_CENTER_ID: "",
            bankInfo: {},
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            isApply: false, // 是否正在申请
            cfgTaInfos: [],
            distributorName: "",
            hasReadProductOverview: false // 是否已完整阅读产品概要
        };
    },
    watch: {
        "fundInfo.transactionaccountid"(val) {
            this.bankInfo = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            this.limitRefresh();
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        },
        checkbox(val) {
            if (val) {
                // 如果已经完整阅读过产品概要，则不再弹出强制阅读
                if (this.hasReadProductOverview) {
                    return;
                }

                this.currentFileInfoList = [];
                this.readFileInfoList.forEach((item) => {
                    if (item.filetype == "7") {
                        this.currentFileInfoList.push(item);
                    }
                });
                if (this.currentFileInfoList.length > 0) {
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        }
    },
    mounted() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));

        this.$util.queryValidPwdTrdMethod("026", (res) => {
            this.isPwdCheck = res;
        });
        this.$set(
            this.fundInfo,
            "transactionaccountid",
            this.fund.fundArr[0].transactionaccountid + this.fund.fundArr[0].index
        );
        this.$set(this.fundInfo, "availablevol", this.fund.fundArr[0].transferusevol);
        this.getFileInfo();
        this.queryCfgTaInfos();
    },
    methods: {
        validateTargetbranchcode(rule, value, callback) {
            if (!value) {
                if (
                    this.fundInfo.targetdistributorcode == "101" ||
                    this.fundInfo.targetdistributorcode == "102"
                ) {
                    return callback(new Error("席位号不能为空"));
                } else {
                    return callback(new Error("托管网点不能为空"));
                }
            }
            callback(); // 验证通过
        },
        validateTargettransactionaccountid(rule, value, callback) {
            if (!value) {
                if (
                    this.fundInfo.targetdistributorcode == "101" ||
                    this.fundInfo.targetdistributorcode == "102"
                ) {
                    return callback(new Error("股东账号不能为空"));
                } else {
                    return callback(new Error("托管交易账号不能为空"));
                }
            }
            callback(); // 验证通过
        },
        // 查询TA信息
        async queryCfgTaInfos() {
            const resArr = await fundApi.queryCfgTaInfos();
            if (resArr.data && resArr.data.data) {
                this.cfgTaInfos = resArr.data.data || [];
                const res = await fundApi.getFundLists({
                    fundcode: this.fund.fundcode,
                    pagesize: 1,
                    pagenum: 1
                });
                if (res.data && res.data.list && res.data.list.length) {
                    const item = res.data.list[0];
                    if (item.tano == "98") {
                        this.fundInfo.targetdistributorcode = "102";
                    } else if (item.tano == "99") {
                        this.fundInfo.targetdistributorcode = "101";
                    } else {
                        this.fundInfo.targetdistributorcode = this.fund.distributorcode;
                    }
                    const info = this.cfgTaInfos.find((ta) => ta.tano == item.tano);
                    this.distributorName = (info && info.taname) || "";
                }
            }
        },
        // 获取披露文件信息
        getFileInfo() {
            this.$util.queryReadFileInfo(
                {
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    filetype: ""
                },
                (res) => {
                    res.forEach &&
                        res.forEach((item) => {
                            item.read = false;
                            if (item.filetype.trim() === "7") {
                                // 产品概要
                                this.readFileInfoList.unshift(item);
                            } else {
                                this.readFileInfoList.push(item);
                            }
                        });
                }
            );
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "7") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            // 如果阅读的是产品概要（filetype === "7"），标记为已完整阅读
            if (this.currentFileInfoList[0] && this.currentFileInfoList[0].filetype === "7") {
                this.hasReadProductOverview = true;
            }
        },
        // 限制只能输入正整数
        handleInput() {
            this.fundInfo.amount = this.fundInfo.amount.replace(/\D/g, "");
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (this.isApply) {
                return;
            }
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
                commonApi.fundFileLeaveTracesLog(this, this.readFileInfoList);
            }
            this.isApply = true;
            setTimeout(() => {
                this.isApply = false;
            }, 3000);
            // 获取留痕申请编号
            const _this = this;
            this.$util.writeFileInfo(
                {
                    readFileInfoList: _this.readFileInfoList,
                    fundcode: _this.fund.fundcode,
                    tano: _this.fund.tano
                },
                (res) => {
                    _this.readappno = res;
                    _this.$refs[formName].validate((valid) => {
                        if (valid) {
                            _this.trusteeshipFund();
                        } else {
                            _this.$errorScroll();
                        }
                    });
                }
            );
        },
        // 发起转托管
        async trusteeshipFund(val) {
            // this.protocol = false;
            // if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                this.isApply = false;
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            try {
                let res = await fundApi.combTrusteeAll({
                    fundcode: _this.bankInfo.fundcode,
                    sharetype: _this.bankInfo.sharetype,
                    contractno: _this.readappno,
                    readappno: _this.readappno,
                    targetdistributorcode: _this.fundInfo.targetdistributorcode,
                    targetbranchcode: _this.fundInfo.targetbranchcode,
                    targettransactionaccountid: _this.fundInfo.targettransactionaccountid,
                    transactionaccountid: _this.bankInfo.transactionaccountid,
                    applicationvol: _this.fundInfo.amount,
                    tradepassword: this.isPwdCheck ? this.$util.enc(_this.fundInfo.pwd) : null
                });
                if (res.data) {
                    this.result.cla = "register-success";
                    this.result.btnMsg = "";
                    // const date = res.data.cfmdate;
                    // this.result.btnMsg =
                    //     "预计确认：" + this.$util.fmtDate(date) + "， 如遇节假日则顺延";
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                const prefix = "您的转托管申请已提交";
                this.result.msg = prefix + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
            } catch (error) {
                this.$log.error(error);
            }
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                if (this.fundInfo.amount === this.bankInfo.transferusevol) {
                    this.isAmountAll = true;
                } else {
                    this.isAmountAll = false;
                }
            }, 1);
        },
        amountLimit(rule, value, callback) {
            rule.mes = "转托管份额";
            this.$util.validateIntegerAmountLimit(this, rule, value, callback);
        },
        // 获取限额
        limitRefresh() {
            this.$set(this.limit, "min", "1");
            this.$set(this.limit, "max", parseInt(this.bankInfo.transferusevol));
            // 切换渠道，清空检验信息
            this.$refs["fundInfo"].clearValidate();
            if (parseInt(this.bankInfo.transferusevol) == 1) {
                this.pla = "本次转换只能转换1份";
            } else if (parseInt(this.bankInfo.transferusevol) < 1) {
                this.pla = "当前没有可转托管份额";
            } else {
                this.pla =
                    "本次转托管范围为" +
                    this.$util.fmtNum(this.limit.min, 0) +
                    "-" +
                    this.$util.fmtNum(this.limit.max, 0) +
                    "份";
            }
            // let res = await fundApi.combQueryTargetFundLimit({
            //     fundcode: this.fund.fundcode,
            //     sharetype: this.fund.sharetype,
            // });
            // if (res.data && res.data.datalist) {
            //     const _max =
            //         Number(this.bankInfo.transferusevol) > Number(res.data.datalist[0].max)
            //             ? res.data.datalist[0].max
            //             : this.bankInfo.transferusevol;
            //     this.$set(this.limit, "max", _max);
            //     if (
            //         this.$util.fmtNum(res.data.datalist[0].min) - 0 >=
            //         this.$util.fmtNum(_max) - 0
            //     ) {
            //         this.$set(this.limit, "min", _max);
            //         this.pla = "本次转换只能全额转换";
            //     } else {
            //         this.$set(this.limit, "min", res.data.datalist[0].min);
            //         this.pla =
            //             "本次转换范围为" +
            //             this.$util.fmtNum(res.data.datalist[0].min) +
            //             "-" +
            //             this.$util.fmtNum(_max) +
            //             "份";
            //     }
            //     if (this.fundInfo.amount) {
            //         this.$refs.fundInfo.validateField("amount");
            //     }
            // }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-trusteeship-fund {
    .el-radio-group.bank-radio .el-radio {
        margin-top: 10px;
    }
    .back {
        color: #666666;
        background: #e4e4e4;
        border-color: transparent;
    }
    .bank-img-sel {
        box-sizing: border-box;
        width: 550px !important;
    }
    .check-text {
        padding-left: 5px;
        color: var(--color-text-primary);
    }
    .cursor-pointer {
        cursor: pointer;
    }
}
</style>
